import fetch from '@/utils/fetch'

export function examinePass (data) {
  return fetch({
    url: '/examinePass',
    data,
    method: 'post'
  })
}

export function updateLastProblemUser (data) {
  return fetch({
    url: '/updateLastProblemUser',
    data,
    method: 'post'
  })
}

export function getDshProblemByID (id) {
  console.log('api---id=' + id)
  return fetch({
    url: '/getDshProblemByID',
    params: {
      id
    },
    method: 'get'
  })
}

export function getProblemByGuidManager (guid) {
  return fetch({
    url: '/getProblemByGuidManager',
    params: {
      guid
    },
    method: 'get'
  })
}

export function checkAnswerByGuid (data) {
  return fetch({
    url: '/checkAnswerByGuid',
    data,
    method: 'post'
  })
}

export function getProblemByGuid (guid) {
  return fetch({
    url: '/getProblemByGuid',
    params: {
      guid
    },
    method: 'get'
  })
}

export function getNextProblemGuid (guid, passtype) {
  return fetch({
    url: '/getNextProblemGuid',
    params: {
      guid,
      passtype
    },
    method: 'get'
  })
}

export function uploadProblemImg (formdata) {
  return fetch({
    url: '/uploadProblemImg',
    method: 'post',
    headers: {'Content-Type': 'multipart/form-data'},
    timeout: 10000,
    data: formdata
  })
}

export function editProblemByGuid (guid) {
  return fetch({
    url: '/editProblemByGuid',
    data: guid,
    method: 'post'
  })
}

export function deltetPreProblemById (id) {
  console.log('api deltetPreProblemById  id =' + id)
  return fetch({
    url: '/deltetPreProblemById',
    data: id,
    method: 'post'
  })
}




// WEBPACK FOOTER //
// ./src/api/api_examine.js